var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"g_id_onload","data-client_id":_vm.clientId,"data-callback":"oneTapCallback","data-context":"signin","data-prompt_parent_id":"g_id_onload"}})}
var staticRenderFns = []

export { render, staticRenderFns }